import React, {useEffect, useState} from 'react';
import Translate from "../../../../../../../../components/Translate";
import {isPositiveInteger} from "../../../../../../../../utils/General";
import Input from "../../../../../../../../components-new/form/Input";
import Switch from "../../../../../../../../components-new/form/Switch";
import colors from "../../../../../../../../utils/Colors";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";
import {updateExpirationTime} from "../../../../../../../../services/company/api";

const inputStyle = {width: '100%', border: 'none', height: '38px', background: 'transparent'};

const ExpirationSettings = ({expiration, client, isFetching}) => {

    const [expireTime, setExpireTime] = useState(expiration ? expiration.expireTime / 60 : 0);
    const [isExpirationEnabled, setIsExpirationEnabled] = useState(expiration ? expiration.enabled : false);

    useEffect(() => {
        setExpireTime(expiration ? expiration.expireTime / 60 : 0);
        setIsExpirationEnabled(expiration ? expiration.enabled : false);
    }, [expiration]);

    const apiUpdate = (time, enabled) => {
        updateExpirationTime(client.id, time, enabled);
    };

    const handleSwitchChange = () => {
        const newValue = !isExpirationEnabled;

        setIsExpirationEnabled(newValue);

        apiUpdate(expireTime * 60, newValue);
    };

    const handleInputChange = (value) => {
        setExpireTime(value);
    };

    const handleInputBlur = () => {
        apiUpdate(expireTime * 60, isExpirationEnabled);
    };

    const validate = (value) => {
        isPositiveInteger(value);
        const parsedValue = Number(value);
        if (parsedValue < 1 || parsedValue > 60) {
            throw new Error("Wrong Range");
        }
    };

    if (!expiration) return null;

    const locked = !isExpirationEnabled || isFetching;

    return (
        <SettingCard
            titleKey="expireConfigs"
            hintKey="expireDescription"
            toggle={
                <Switch
                    checked={isExpirationEnabled}
                    onChange={handleSwitchChange}
                    style={{color: colors.silverBlue}}
                />
            }
        >
            <div className={'setting-body setting-body--compact'
                + (!isExpirationEnabled ? ' setting-body--off' : '')}>
                <div className="setting-number">
                    <div className="setting-number__box">
                        <Input
                            type="number"
                            style={inputStyle}
                            value={expireTime}
                            validate={validate}
                            onChange={(e) => handleInputChange(e.target.value)}
                            onBlur={handleInputBlur}
                            disabled={locked}
                        />
                    </div>
                    <span className="setting-number__unit"><Translate text="min"/></span>
                </div>
            </div>
        </SettingCard>
    );
};

export default ExpirationSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/ExpirationSettings.jsx